var _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#C3A157"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 41,
    fill: "url(#paint0_radial_7608_72678)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 47.9019C63.5 49.0566 63.5 51.9434 61.5 53.0981L45.75 62.1913C43.75 63.346 41.25 61.9027 41.25 59.5933V41.4067C41.25 39.0973 43.75 37.654 45.75 38.8087L61.5 47.9019Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7608_72678",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5 17.5) rotate(52.4094) scale(79.5063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "#D0AC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B18B3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.e52cbc020ceaf6062c8adacc5bc8327c.svg";
export { ForwardRef as ReactComponent };